import axios from 'axios';
import Vue from "vue";
import Vuex from "vuex";
import CleanAirZone from "./CleanAirZone.vue";
import { navigator } from "./navigator";

export default function (element) {
    const data = JSON.parse(element.dataset.data);
    Vue.use(Vuex);

    const store = new Vuex.Store({
        state: {
            heading: data.heading,
            images: data.images,
            registration: "",
            vehicle: null,
            navigator: navigator,
            location: null,
            place: null,
        },
        mutations: {
            setRegistration(state, registration) {
                state.registration = registration;
            },
            setVehicle(state, vehicle) {
                state.vehicle = vehicle;
            },
            setStep(state, step) {
                state.navigator.step = step;
            },
            setLocation(state, location) {
                state.location = location;
            },
            setPlace(state, place) {
                state.place = place;
            },
        },
        actions: {
            navigatorStep({ commit, state }, step) {
                commit("setStep", step);
            },
            resetFlow({ commit, state }) {
                commit("setStep", state.navigator.steps[0].step);
                commit("setRegistration", "");
                commit("setVehicle", null);
            },
            fetchVehicleLocation({ commit, state }) {
                return new Promise((resolve, reject) => {
                    axios
                    .post('/api/clean-air-zone/vehicle-location', {
                        registration: state.registration,
                        location: state.location,
                    })
                    .then((response) => {
                        commit("setVehicle", response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
                });
            },
        },
        getters: {
            currentStep(state) {
                return state.navigator.steps.find(
                    (step) => step.step === state.navigator.step
                );
            },
        },
    });

    const vueApp = new Vue({
        el: element,
        components: {
            CleanAirZone,
        },
        store: store,
        template: "<CleanAirZone />",
    });
}
